import { PatientEntitlementType } from '@dreryk/egabinet-patient-frontend-api';

import { useFormController } from '@dreryk/react-common';

import {
   PatientEntitlementTypeSelectorFormBean,
   PatientEntitlementTypeSelectorFormController,
} from './PatientEntitlementTypeSelectorForm.types';

type PatientEntitlementTypeSelectorFormControllerOptions = {
   initialPatientEntitlementType: PatientEntitlementType | undefined;
};

export const usePatientEntitlementTypeSelectorFormController = (
   options: PatientEntitlementTypeSelectorFormControllerOptions
): PatientEntitlementTypeSelectorFormController => {
   return useFormController<PatientEntitlementTypeSelectorFormBean>({
      patientEntitlementType: options.initialPatientEntitlementType ?? null,
   });
};
